import { Injectable} from "@angular/core";
import { BaseApiService} from "../services/base-api-service";
import { Observable} from "rxjs";
import { ApiType } from "../enums/api-type";
import { RequestType } from "../enums/RequestType";
import {map} from "rxjs/operators";
import { AuthService } from "../../website/services/auth.service";

@Injectable({providedIn: 'root'})
export class AccountApi {

  constructor(
    private readonly apiClient: BaseApiService,
    private readonly authService: AuthService

  ) {
  }

  getFirebaseToken(): Observable<string> {
    return  this.apiClient.call<{}, string>({
      apiType: ApiType.getFirebaseToken,
      requestType: RequestType.GET
    })
  }

  logout(): Observable<void> {
    console.log("Calling request")
    return this.apiClient.call<{}, void>({
      apiType: ApiType.logout,
      requestType: RequestType.POST
    }).pipe(
      map(() => {
        this.apiClient.clearJWTToken();
        this.authService.onAuthChanged()
        console.log("Logged out now..")
      })
    )
  }
}
